import { defineComponent as _defineComponent } from 'vue'
import { useUpdateAllIroStatusesLazyQuery } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'iro',
  setup(__props) {

const { load, refetch } = useUpdateAllIroStatusesLazyQuery()

const triggerUpdateAllIroStatuses = () => {
  load() || refetch()
}

return { __sfc: true,load, refetch, triggerUpdateAllIroStatuses }
}

})